<div class="ds-timeline">
  @if (showHeader) {
    <div class="ds-timeline-header">
      <h2 class="ds-heading-1">{{ header | translate }}</h2>
      @if (showMarkAsSeen) {
        <a class="ds-ui-3 ds-color-core-neutral-8" href="javascript:;" (click)="onMarkAllAsSeen()">{{ markAllAsSeenText | translate }}</a>
      }
    </div>
  }

  @for (item of items; track item; let last = $last) {
    <div class="ds-timeline-item" (click)="onMarkAsSeen(item.id)">
      <div class="ds-timeline-icon">
        <app-ds-rounded-icon
          size="medium"
          [icon]="getTimelineIcon(item.type)"
          [customColor]="item.seen ? 'var(--color-core-neutral-3)' : 'var(--color-core-brand-1-5)'"
          [color]="item.seen ? 'var(--color-core-neutral-10)' : 'var(--color-core-neutral-0)'"
        ></app-ds-rounded-icon>
      </div>
      <div class="ds-timeline-content">
        <span class="ds-ui-3 ds-color-core-neutral-5">{{ getFormatedDate(item.happened_on) }}</span>
        <div class="ds-ui-2" [ngClass]="item.seen ? 'ds-color-core-neutral-6' : 'ds-color-core-neutral-10'" [innerHTML]="item.description"></div>
      </div>
    </div>

    @if (items.length > 1 && !last) {
      <div class="ds-timeline-separator"></div>
    }
  }
</div>
